const defaultGlobalState = {
  defaultAccountNumber: null,
  user: null, //user in defaultGlobalState has the email address
  userId: null,
  serviceAccounts: null,
  selectedServiceAccountIndex: null,
  pastPayments: null,
  jwt: null,
  siteDetails: {
    mcwa_water_quality_report_url:
      'https://www.mcwa.com/my-water/water-quality/water-quality-reports/',
    mcwa_all_faqs_url: 'https://www.mcwa.com/my-water/water-faqs',
    mcwa_automatic_bill_pay_url:
      'https://mcwa-wordpress-media.s3.amazonaws.com/wp-content/uploads/AUTHORIZATION-FORM-AUTO-PAY-ONLINE-MAY-2020.pdf',
    mcwa_need_help_url:
      'https://mcwa.com/customer-service/customer-service-know-your-bill',
    mcwa_support_how_to_read_a_meter:
      'https://mcwa.com/customer-service/customer-service-meter-information/customer-service-how-to-read-a-meter/',
    mcwa_contact_phone: '585-442-2000',
    mcwa_support_email: 'information@mcwa.com',
    mcwa_support_hours: 'Monday-Friday 8:30AM - 4:30PM',
    mcwa_contact_emergency_phone: '585-442-2009',
  },
  faqs: null,
  messages: null,
  resetPasswordError: false,
  forgotPasswordToken: null,
};

export default defaultGlobalState;
